/**
 * FC トップ: README.txt モーダル（nigami-reference/assets/js/fc-readtxt-modal.js 準拠）
 */
(function () {
  var modal = document.getElementById('fc-readtxt-modal');
  var openEl = document.getElementById('fc-readtxt-open');
  var closeBtn = document.getElementById('fc-readtxt-close');
  if (!modal || !openEl) return;

  var scroll = modal.querySelector('[data-readtxt-scroll]');
  if (scroll && !scroll.querySelector('#fc-readtxt-modal-title')) {
    var heading = scroll.querySelector('h1, h2');
    if (heading) {
      heading.id = 'fc-readtxt-modal-title';
    }
  }

  function setOpenModal(open) {
    if (open) {
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fc-readtxt-modal-open');
      if (closeBtn) {
        closeBtn.focus();
      } else {
        var dialog = document.getElementById('fc-readtxt-modal-dialog');
        if (dialog) dialog.focus();
      }
    } else {
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fc-readtxt-modal-open');
      openEl.focus();
    }
  }

  openEl.addEventListener('click', function (e) {
    e.preventDefault();
    setOpenModal(true);
  });

  /** 白いウィンドウ外（暗いオーバーレイ含む）をクリックで閉じる */
  modal.addEventListener('click', function (e) {
    if (modal.hasAttribute('hidden')) return;
    if (e.target.closest('.fc-readtxt-modal__window')) return;
    setOpenModal(false);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      setOpenModal(false);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (modal.hasAttribute('hidden')) return;
    e.preventDefault();
    setOpenModal(false);
  });
})();
